import { ApiRoutes } from '@gr/core/api-routes';
import { PUBLIC_CONFIG_DEFAULTS, type PublicConfig } from '@gr/core/platform/config/public-config';
import type { HttpClient } from '../http/http-client';
import { Observable } from '../store';

/**
 * CFG-UC-1 (ADR-013): публичная конфигурация платформы в интерфейсе. До ответа сервера, без
 * сети и в Storybook действуют умолчания из реестра; ответ сервера их заменяет. Перечитывается,
 * когда администратор изменил публичный параметр (событие configChanged). У вошедшего сервер
 * отдаёт её с личными значениями (PREF-UC-3).
 */
export class ConfigService {
  readonly value = new Observable<PublicConfig>(PUBLIC_CONFIG_DEFAULTS);
  /** Для кого загружена: до входа — null. */
  private user: string | null = null;

  constructor(private readonly http: Pick<HttpClient, 'get'>) {}

  /** PREF-UC-3.CC-2: сменился пользователь (вход, выход, другой вход) — перечитать с его личными значениями. */
  followUser(userId: string | null): void {
    if (userId === this.user) return;
    this.user = userId;
    void this.load();
  }

  /** Загрузить с сервера; при ошибке остаются прежние значения — интерфейс работает дальше. */
  async load(): Promise<void> {
    const result = await this.http.get<PublicConfig>(ApiRoutes.config.public);
    if (result.success && result.data) this.value.set(result.data);
  }

  get current(): PublicConfig {
    return this.value.get();
  }
}
